import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

const initSwiper = () => {
    const swiperDisableBreakpoint = window.matchMedia('(min-width: 1024px)');
    let swiperInstance;

    const breakpointChangeEventListener = () => {
        if (swiperDisableBreakpoint.matches) {
            if (swiperInstance) {
                swiperInstance.destroy();
            }

            return;
        }

        enableSwiper();
    };

    const enableSwiper = () => {
        swiperInstance = new Swiper('.swiper', {
            modules: [Pagination],

            direction: 'horizontal',
            loop: false,

            slidesPerView: 1.3,
            centeredSlides: true,
            spaceBetween: 0,

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    };

    swiperDisableBreakpoint.addEventListener('change', breakpointChangeEventListener);
    breakpointChangeEventListener();
};

if (document.querySelectorAll('.swiper').length > 0) {
    initSwiper();
}
